<template>
  <div
    v-if="show && !isHor"
  >
    <AwardDialog
      v-if="!showProtocolDialog && showAwardDialog"
      :award-list="awardList"
      :cur-role-name="curRoleName"
      @dimissDialog="onCloseAwardDialog"
      @onShowSwitchRoleDialog="onShowSwitchRoleDialog"
      @onExchange="onExchange"
      @onGoAward="onGoAward"
    />

    <SwitchRoleDialog
      v-if="showSelectRoleDialog"
      :show="showSelectRoleDialog"
      :selected-n-role-idx="curGameInfo.roleidx"
      :is-modify="true"
      :refresh="false"
      :role-list="roleList"
      @dissmissDialog="showSelectRoleDialog=false"
      @onClickSelect="onRoleChange"
    />

    <UIMatchPayStatus
      v-if="showPayStatusDialog"
      :match-status="true"
      :pay-success="paySuccess"
      @onSucCallback="onGoAward"
      @onRepay="onClosePayDialog"
      @onDelete="onClosePayDialog"
      @dismissDialog="onClosePayDialog"
    />
  </div>
</template>

<script>
import { post } from '@tencent/pmd-network';
import { requestMyGoodsV2 } from 'src/component/logic/tip-merchant/goods/list';
import AwardDialog from 'src/local-component/ui/tip-match/tip-match-get-award-popup';
import SwitchRoleDialog from 'src/local-component/module/tip-match/tip-match-select-role-award';
import { getBatchMyAwardDetail } from 'src/local-logic/tip-match/my-award/my-award-detail';
import { selectRoleMixin } from 'src/local-component/module/tip-match/poll-get-my-award/select-role-mixin';
import { batchExchangeAwards } from 'src/local-logic/tip-match/my-award/exchange-award';
import UIMatchPayStatus from 'src/local-component/ui/tip-match/tip-match-pay-status/index.vue';

const LOCAL_KEY = 'NEW_AWARDS_KEYS';

function isNewList(data = []) {
  if (!data[0] || !data[0].winningtime) return false;
  const local = localStorage.getItem(LOCAL_KEY) || '';
  if (!local) return true;

  if (local != data[0].winningtime) {
    return true;
  }
  return false;
}

function saveToLocal(data = []) {
  localStorage.setItem(LOCAL_KEY, data?.[0]?.winningtime || '');
}

export default {
  components: {
    AwardDialog,
    SwitchRoleDialog,
    UIMatchPayStatus,
  },
  mixins: [selectRoleMixin],
  props: {
    childId: {
      type: String,
      desc: '指定赛事id',
      default: '',
    },
  },
  data() {
    return {
      show: false,
      showAwardDialog: false,
      awardList: [],
      showPayStatusDialog: false,
    };
  },
  computed: {
    showProtocolDialog() {
      return this.$store.state?.protocol?.showDialog || false;
    },
    paySuccess() {
      return {
        statusDesc: '领取成功',
        tipDesc: '游戏道具请前往"游戏-礼品中心"中查看并领取。',
        btnDesc: '查看奖励',
      };
    },
  },
  mounted() {
    this.getGoodsList();
  },
  methods: {
    refreshGetGoodsList() {
      localStorage.removeItem(LOCAL_KEY);
      this.getGoodsList();
    },
    getGoodsList() {
      requestMyGoodsV2({
        goodsstatus: 4,
        filter1: 'saibao',
        filter2: this.childId ?? '',
        // pageidx: pageIdx,
        url: '/PromoPlatform.Game.exchange.exchange/QueryUserWaterList',
        goodsTypeFilter: [16, 36],
      }).then((res) => {
        console.log('[getGoodsList] res', res);
        const { 1: awardList = [] } = res;

        getBatchMyAwardDetail(awardList).then((resp) => {
          console.log('[getBatchMyAwardDetail] resp: ', resp);
          (resp || []).forEach((item) => {
            item.propsNum = item.extrainfo?.game_prop_info?.send_goods_num || 1;
          });
          this.handleAwardList(resp || []);
        })
          .catch((err) => {
            console.log('[getBatchMyAwardDetail] err: ', err);
          });
      });
    },
    handleAwardList(awardList) {
      const list = awardList.map(item => ({
        ...item,
        ...(item.goodscfg || {}),
      }));

      this.awardList = list;
      const hasNewGoods = isNewList(list);
      console.log('[hasNewGoods]: ', hasNewGoods, list);
      if (hasNewGoods) {
        this.fetchRoleInfo().finally(() => {
          this.show = true;
          this.showAwardDialog = true;
        });
      }
    },
    onClosePayDialog() {
      this.showPayStatusDialog = false;
    },
    onCloseAwardDialog() {
      this.showAwardDialog = false;
      this.show = false;
      saveToLocal(this.awardList);
    },
    onShowSwitchRoleDialog() {
      this.showSelectRoleDialog = true;
    },
    onExchange() {
      const { awardList, curGameInfo } = this;
      if (!curGameInfo.roleidx) {
        this.showToast('兑换失败，没有查询到角色');
        return;
      }
      // const newInfo = this.awardList[0];
      // console.log('[onExchange]', newInfo);
      // onClickExchange.call(newInfo, getHost());

      batchExchangeAwards(awardList, curGameInfo).then((resp) => {
        console.log('[onExchange] resp', resp);
        this.showPayStatusDialog = true;
        // this.show = false;
        this.$emit('onExchange');
      })
        .catch((err) => {
          console.log('[err]', err);
        });
    },
    onGoAward() {
      uni.navigateTo({ url: '/views/award/my-award' });
      this.show = false;
    },
  },
};
</script>
